module.exports = __webpack_public_path__ + "img/avatar-37.8686e4a5.png";